import { z } from 'zod';
import { SyncableEntitySchema } from './entity';

export const StudentProfileSchema = SyncableEntitySchema.extend({
  candidateId: z.string().default(''),
  fullName: z.string().default(''),
  stream: z.string().default('G.C.E. Advanced Level'),
  targetYear: z.number().int().default(2026),
  targetZScore: z.number().min(0).max(4.0).nullable().default(2.85),
  targetDistrictRank: z.number().int().positive().nullable().default(10),
  bio: z.string().default('G.C.E. Advanced Level student'),
  avatarUrl: z.string().nullable().default(null),
});
export type StudentProfile = z.infer<typeof StudentProfileSchema>;

export const PreferenceSchema = z.object({
  key: z.string().min(1),
  value: z.string(),
  updatedAt: z.string().datetime(),
});
export type Preference = z.infer<typeof PreferenceSchema>;
